import * as React from 'react'
import {connect} from 'react-redux'

import RunningBuildUpdater from '../../../../containers/RunningBuildUpdater'
import type {State} from '../../../../reducers/types'
import {getAgent} from '../../../../selectors'
import {stringifyId} from '../../../../types'
import type {AgentId} from '../../../../types'
import Visible from '../../../common/Visible/Visible'

import type {AgentListItemProps} from './Agent'
import Agent from './Agent'

type Props = {
  agentId: AgentId
}

const mapStateToProps = (state: State, props: Props) => {
  const agent = getAgent(state, props.agentId)
  return {
    isActive: agent?.connected && agent?.authorized,
    isAuthorized: agent?.authorized,
    isIdle: agent == null || !('build' in agent),
    buildId: agent?.build,
    ip: agent?.ip,
  }
}

class AgentContainer extends React.Component<AgentListItemProps> {
  render() {
    const {buildId, agentId} = this.props
    return (
      <Visible id={`agent:${stringifyId(agentId)}`}>
        {isVisible => (
          <React.Fragment>
            {isVisible && buildId != null && <RunningBuildUpdater buildId={buildId} />}
            <Agent {...this.props} isVisible={isVisible} />
          </React.Fragment>
        )}
      </Visible>
    )
  }
}

export default connect(mapStateToProps)(AgentContainer)
